import React, {useContext, useState, useEffect} from 'react';

// Import Css
import './photoPlanningCompoent.css';

// Import Assets    
import IconGoogle from '../../assets/iconMobileDesing/Icon-MD-Google.svg'
import IconHandPush from '../../assets/iconEnfoque/Icon-Enfoque-hand.svg'


export function PhotoPlanningComponent({bkPhotoPlannig, iconPlanning, titlePlanning, textCortinaPlanning}) {


    const bkPhotoPlanningStyle = {

        backgroundImage: `url(${bkPhotoPlannig})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'

    }



    return(       

        <div className='container-photo-planning' style={bkPhotoPlanningStyle}>


            <div className='box-filtro-planning'>
                <img className='icon-planning' src={iconPlanning}/>
                <p className='title-planning'>{titlePlanning}</p> 
            </div>

            <div className='box-cortina-planning'>

                <p className='text-cortina-planning'>{textCortinaPlanning}</p>

                <img className='icon-google' src={IconGoogle} alt='Buscador Google'/>
                
            </div> 
            
            
            <img className='iconHandPush' src={IconHandPush} alt='Click Push'/>


        </div>
        
    );

}